const productionBaseUrl = process.env.REACT_APP_BASE_URL;
export const baseUrl = productionBaseUrl
  ? productionBaseUrl
  : "https://app.avagap.com/api";

export const storageBaseUrl = 'https://app.avagap.com/api';

export const toCoverUrl = (coverId: string | null) =>
  coverId === null
    ? "https://eu-de-1.cdn.avagap.com/cover/default.jpg"
    : `https://eu-de-1.asset.avagap.com/${coverId}`;
